import React from 'react';
import { PlatformFeeHover } from './PlatformFeeHover';
import { v4PlanPrices } from '../../../constants/pricing';

interface StandardPlanColumnSubtitleProps {
  togglePayPeriod: string;
}

export const StandardPlanColumnSubtitle = ({
  togglePayPeriod,
}: StandardPlanColumnSubtitleProps) => {
  const [showPlatformHover, setShowPlatformHover] = React.useState(false);
  const key = `standard-plan-4-${togglePayPeriod}`;
  const planPrices = v4PlanPrices[key];

  return (
    <p className="mt-5">
      <span className="fsz-16 center">Plus&nbsp;</span>
      <span className="bold-800">
        $
        {planPrices.platformPrice}
        /mo
      </span>
      &nbsp;platform fee&nbsp;
      <span
        className="orange info-icon"
        onMouseEnter={() => setShowPlatformHover(true)}
        onMouseLeave={() => setShowPlatformHover(false)}
      >
        ⓘ
      </span>
      <PlatformFeeHover show={showPlatformHover} />
    </p>
  );
};
